import React from 'react';
import { Router, Route, browserHistory } from 'react-router'
import * as authApi from './api/auth-api';
import { getUserProfileSuccess } from 'actions/user-actions';
import { getAssetsSuccess } from 'actions/asset-actions';
import _ from 'lodash';
import * as assetApi from "api/asset-api";

// Layouts
import MainLayout from './components/layouts/main-layout';

// Pages
import GalleryContainer from './components/containers/gallery-container';
import MediaAssetContainer from './components/containers/media-asset-container';
import LoginFormContainer from './components/containers/login-form-container';
import UploadListContainer from './components/containers/upload-list-container';

import store from './store';

function onEnter(onAuthSuccess) {
    return function requireCredentials(nextState, replace, next) {
        const state = store.getState();
        let userProfile = state.userProfile;
        const handleSuccessfulAuthentication = (profile) => {
            if (nextState.location.pathname === '/login') {
                replace('/');
            }

            if (!onAuthSuccess) {
                next();
                return;
            }
            onAuthSuccess(profile).then(() => {
                next();
            });
        };

        if (_.isEmpty(userProfile) || !_.isEmpty(userProfile.loginError)) {
            authApi.getUserProfile().then((profile) => {
                store.dispatch(getUserProfileSuccess(profile));
                handleSuccessfulAuthentication(profile);
            }).catch(error => {
                if (error.response) {
                    // The request was made, but the server responded with a status code
                    // that falls out of the range of 2xx
                    console.error(error.response.status);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.error('Error', error.message);
                }
                if (nextState.location.pathname !== '/login') {
                    replace('/login');
                }
                next();
            })
        } else {
            handleSuccessfulAuthentication(userProfile);
        }
    }
}

function getAssets(profile) {
    if (!profile || !profile.programmers) { return Promise.resolve() ;}
    const state = store.getState();
    return new Promise(resolve => {
        if (state.assetsState.assets === null) {
            assetApi.getAssets(profile.employeeId, profile.programmers[0].id).then(response => {
                store.dispatch(getAssetsSuccess(response.data.assets));
                resolve(response.data.assets);
            })
        } else {
            resolve(state.assetsState.assets);
        }
    });
}

export default (
    <Router history={browserHistory}>
        <Route component={MainLayout}>
            <Route path='/' component={GalleryContainer} onEnter={onEnter(getAssets)}>
            </Route>
            <Route path='uploads' component={UploadListContainer} onEnter={onEnter()}/>
        </Route>
        <Route path='/assets/:id' component={MediaAssetContainer} onEnter={onEnter(getAssets)}/>
        <Route path='/login' component={LoginFormContainer} onEnter={onEnter()}/>
    </Router>
);
